/* eslint-disable @next/next/no-img-element */
import React from 'react'
import { gsColors } from '../styles/Variables'
import { mq } from '../helpers'
import { Text } from '../styles/Components'
import styled from '@emotion/styled'

// arrow button in booking flow

const StyledArrowButton = styled.button`
  display: flex;
  justify-content: space-between;
  background-color: ${gsColors.sunsetOrange};
  border: none;
  width: 361px;
  height: 80px;
  padding: 12px 16px;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  position: relative;
  cursor: pointer;

  ${props => props.margin ? `margin: ${props.margin};` :  ''}

  ${mq('max', '768px')} {

    ${props => props.footer ? `
      box-sizing: border-box;
      width: 100% !important;
      // margin: 0 16px 16px;
      border: 16px solid #FFF;
      border-top: none;
    ` : `
      width: 340px;
      height: 54px;
      padding: 12px 16px;
      flex-shrink: 0;
    `}
  }
  
  &:disabled {
    &::after {
      content: '';
      height: 100%;
      width: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background-color: rgba(255, 255, 255, 0.5);
    }
  }

  p {
    ${mq('max', '768px')} {
      font-size: 16px;
    }
  }
`

const ArrowButton = ({ 
  children, 
  className, 
  margin,
  onClick,
  disabled,
  footer,
}) => {
  return (
    <StyledArrowButton
      footer={footer}
      onClick={onClick}
      disabled={disabled}
      margin={margin ? margin : ''}
      className={className ? className : ''}
    >
      <Text
        color='#fff'
        fontSize={18}
        weight={600}
        spacing={1.44}
        lineHeight='100%'
      >
        {children}
      </Text>
      <img src='/images/arrow-right.svg' alt='' aria-hidden='true' />
    </StyledArrowButton>
  )
}

export default ArrowButton
